import { useMutation, useQueryClient } from 'react-query';
import { makeRequest } from '../../api/makeRequest';


interface UseUpdateMutationOptions<TResponse> {
    queryKey?: string | any[];
    path: string;
    onSuccess?: (response: TResponse) => void;
    onError?: (error: Error) => void;
}

export function useUpdateMutation<TRequest, TResponse = unknown>({ queryKey, path, onSuccess, onError }: UseUpdateMutationOptions<any>) {
    const queryClient = useQueryClient();

    return useMutation<TResponse, unknown, TRequest>(
        item =>
            makeRequest({
                method: 'PUT',
                path,
                data: item
            }),
        {
            onSuccess: async response => {
                if (queryKey) {
                    await queryClient.invalidateQueries(queryKey);
                }
                onSuccess && onSuccess(response);
            },
            onError: error => {
                if (onError && error instanceof Error) {
                    onError(error)
                }
            }
        }
    );
}
